import { DEFAULT_FIVERR_LOCALE, SUPPORTED_FIVERR_LOCALES_KEYS } from '@fiverr-private/localization';

const genericOptimizedVideoAssetPath =
    'https://fiverr-res.cloudinary.com/video/upload/f_auto:video,q_auto:best/v1/video-attachments/generic_asset/asset/';

export const HOW_FIVERR_WORKS_VIDEO_SOURCES = {
    [SUPPORTED_FIVERR_LOCALES_KEYS.EN_US]: {
        desktop: {
            src: `${genericOptimizedVideoAssetPath}618be487b413e648c135d6401cb2da2f-1754927870911/How%20Fiverr%20Works%2016x9`,
            type: 'video/mp4',
        },
        mobile: {
            src: `${genericOptimizedVideoAssetPath}618be487b413e648c135d6401cb2da2f-1754927870920/How%20Fiverr%20Works%204x5`,
            type: 'video/mp4',
        },
    },
    [SUPPORTED_FIVERR_LOCALES_KEYS.DE_DE]: {
        desktop: {
            src: `${genericOptimizedVideoAssetPath}618be487b413e648c135d6401cb2da2f-1754927912007/How%20Fiverr%20Works%20DE%20Subs%2016x9`,
            type: 'video/mp4',
        },
        mobile: {
            src: `${genericOptimizedVideoAssetPath}618be487b413e648c135d6401cb2da2f-1754927911997/How%20Fiverr%20Works%20DE%20Subs%204x5`,
            type: 'video/mp4',
        },
    },
    [SUPPORTED_FIVERR_LOCALES_KEYS.ES]: {
        desktop: {
            src: `${genericOptimizedVideoAssetPath}618be487b413e648c135d6401cb2da2f-1754927912010/How%20Fiverr%20Works%20ES%20Subs%2016x9`,
            type: 'video/mp4',
        },
        mobile: {
            src: `${genericOptimizedVideoAssetPath}618be487b413e648c135d6401cb2da2f-1754927912010/How%20Fiverr%20Works%20ES%20Subs%204x5`,
            type: 'video/mp4',
        },
    },
    [SUPPORTED_FIVERR_LOCALES_KEYS.FR_FR]: {
        desktop: {
            src: `${genericOptimizedVideoAssetPath}618be487b413e648c135d6401cb2da2f-1754927912009/How%20Fiverr%20Works%20FR%20Subs%2016x9`,
            type: 'video/mp4',
        },
        mobile: {
            src: `${genericOptimizedVideoAssetPath}618be487b413e648c135d6401cb2da2f-1754927912007/How%20Fiverr%20Works%20FR%20Subs%204x5`,
            type: 'video/mp4',
        },
    },
    [SUPPORTED_FIVERR_LOCALES_KEYS.IT_IT]: {
        desktop: {
            src: `${genericOptimizedVideoAssetPath}618be487b413e648c135d6401cb2da2f-1754927911997/How%20Fiverr%20Works%20IT%20Subs%2016x9`,
            type: 'video/mp4',
        },
        mobile: {
            src: `${genericOptimizedVideoAssetPath}618be487b413e648c135d6401cb2da2f-1754927911997/How%20Fiverr%20Works%20IT%20Subs%204x5`,
            type: 'video/mp4',
        },
    },
    [SUPPORTED_FIVERR_LOCALES_KEYS.PT_BR]: {
        desktop: {
            src: `${genericOptimizedVideoAssetPath}618be487b413e648c135d6401cb2da2f-1754927911999/How%20Fiverr%20Works%20PT%20Subs%2016x9`,
            type: 'video/mp4',
        },
        mobile: {
            src: `${genericOptimizedVideoAssetPath}25af4a2b64c9d178897867bf77950a36-1754928487870/How%20Fiverr%20Works%20PT%20Subs%204x5`,
            type: 'video/mp4',
        },
    },
    [SUPPORTED_FIVERR_LOCALES_KEYS.NL_NL]: {
        desktop: {
            src: `${genericOptimizedVideoAssetPath}618be487b413e648c135d6401cb2da2f-1754927911997/How%20Fiverr%20Works%20NL%20Subs%2016x9`,
            type: 'video/mp4',
        },
        mobile: {
            src: `${genericOptimizedVideoAssetPath}618be487b413e648c135d6401cb2da2f-1754927912009/How%20Fiverr%20Works%20NL%20Subs%204x5`,
            type: 'video/mp4',
        },
    },
};

export const HOW_FIVERR_WORKS_VIDEO_DEFAULT_SOURCE = HOW_FIVERR_WORKS_VIDEO_SOURCES[DEFAULT_FIVERR_LOCALE];
